<template>
	<input
		v-model="displayVal"
		:type="type"
		:id="inputId || 'INPUT_' + _uid"
		:autocomplete="autocomplete"
		:class="[
			'text-gray-900 placeholder-gray-400 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md',
			markInvalid
				? 'text-red-600 border-red-600 border-1 bg-red-100 shadow-sm focus:text-gray-900'
				: '',
			inValid
				? 'text-red-600 border-red-600 border-1 bg-red-100 shadow-sm focus:text-gray-900'
				: '',
			disabled ? 'text-gray-500 bg-gray-100' : '',
		]"
		:disabled="disabled"
		@blur="onBlur"
		@focus="validationErrors = null"
	/>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
		},
		type: {
			type: String,
			default: "text",
		},
		autocomplete: {
			type: String,
			default: "on",
		},
		autoReplace: {
			required: false,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		markInvalid: {
			type: Boolean,
			default: false,
		},
		inputId: {
			type: String,
		},
		dp: {
			type: Number,
			default: null,
		},
		maxValue: {
			type: Number,
			default: null,
			required: false,
		},
		showZeroValue: {
			type: Boolean,
			default: false,
			required: false,
		},
		field: {
			type: String,
			default: null,
			required: false,
		},
	},
	data() {
		let decimalSeparator = this.locale == "de" ? "," : ".",
			val = this.value
				? "" + this.value
				: this.showZeroValue && this.value == "0"
				? this.value
				: "";

		return {
			decimalSeparator: decimalSeparator,
			val: val,
			displayVal: this.dp === null ? val : val.replace(".", decimalSeparator),
			validationErrors: null,
		};
	},
	mounted() {
		this.$bus.$off("form:invalid", this.setValidationErrors);
		this.$bus.$on("form:invalid", this.setValidationErrors);
	},
	computed: {
		inValid() {
			return this.validationErrors?.length > 0;
		},
	},
	methods: {
		setValidationErrors(event) {
			this.validationErrors = event[this.field];
		},
		maybeCompleteDecimalPlaces() {
			if (this.dp === null || this.displayVal == "") {
				return;
			}
			let pieces = this.displayVal.split(this.decimalSeparator);
			if (pieces.length == 1) {
				pieces.push("0".repeat(this.dp));
			} else if (pieces[1].length < this.dp) {
				pieces[1] = pieces[1] + "0".repeat(this.dp - pieces[1].length);
			} else {
				pieces[1] = pieces[1].substr(0, this.dp);
			}
			this.displayVal =
				this.dp == 0 ? pieces[0] : pieces.join(this.decimalSeparator);
		},
		notifyInputChange() {
			this.val = this.displayVal;
			if (this.autoReplace) {
				this.val = this.displayVal.replace(this.decimalSeparator, ".");
			}
			this.$emit("input", this.val);
			this.$emit("change");
		},
		onBlur() {
			this.maybeCompleteDecimalPlaces();
			this.notifyInputChange();
		},
	},
	watch: {
		/**
		 * Hält die Anzeige (`displayVal`) mit dem von außen gebundenen `value`-Prop synchron.
		 *
		 * Hintergrund: `displayVal` wird in `data()` nur EINMAL initial aus `value` abgeleitet.
		 * Ohne diesen Watcher würde eine spätere Prop-Änderung durch den Parent (asynchron
		 * nachgeladene Formulardaten, Reset, programmatisches Setzen) nicht mehr im Feld
		 * ankommen — das Feld bliebe auf dem Initialwert stehen.
		 *
		 * Ablauf:
		 *  1. `value` robust in einen String wandeln; null/undefined/'' werden zu '' normalisiert
		 *     (leeres Feld statt der Texte "null"/"undefined").
		 *  2. Bei Zahlenfeldern (`dp !== null`) den technischen Punkt in den lokalen
		 *     Dezimaltrenner (z.B. ',') übersetzen; reine Textfelder (`dp === null`) bleiben roh.
		 *  3. Nur zuweisen, wenn sich der Wert wirklich unterscheidet. Der Guard verhindert eine
		 *     Rückkopplung mit dem `displayVal`-Watcher und ein unnötiges Überschreiben des
		 *     Feldes während einer laufenden Nutzereingabe.
		 *
		 * @param {*} v Neuer Wert des `value`-Props
		 */
		value(v) {
			const strVal = v !== null && v !== undefined && v !== '' ? '' + v : '';
			const formatted = this.dp === null ? strVal : strVal.replace('.', this.decimalSeparator);

			if (formatted !== this.displayVal) {
				this.displayVal = formatted;
			}
		},
		displayVal(v) {
			/*this.val = v.replace(this.decimalSeparator, '.');
            this.$emit('input', this.val);
            this.$emit('change');*/
			if (this.maxValue !== null && parseInt(v) > this.maxValue) {
				this.displayVal = this.maxValue;
			}
		},
	},
	beforeDestroy() {
		this.$bus.$off("form:invalid", this.setValidationErrors);
	},
};
</script>
